"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PodcastShowsResponseToJSON = exports.PodcastShowsResponseFromJSONTyped = exports.PodcastShowsResponseFromJSON = exports.instanceOfPodcastShowsResponse = void 0;
var runtime_1 = require("../runtime");
var ContentPromotionBase_1 = require("./ContentPromotionBase");
/**
 * Check if a given object implements the PodcastShowsResponse interface.
 */
function instanceOfPodcastShowsResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfPodcastShowsResponse = instanceOfPodcastShowsResponse;
function PodcastShowsResponseFromJSON(json) {
    return PodcastShowsResponseFromJSONTyped(json, false);
}
exports.PodcastShowsResponseFromJSON = PodcastShowsResponseFromJSON;
function PodcastShowsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'shows': !(0, runtime_1.exists)(json, 'shows') ? undefined : (json['shows'].map(ContentPromotionBase_1.ContentPromotionBaseFromJSON)),
    };
}
exports.PodcastShowsResponseFromJSONTyped = PodcastShowsResponseFromJSONTyped;
function PodcastShowsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'shows': value.shows === undefined ? undefined : (value.shows.map(ContentPromotionBase_1.ContentPromotionBaseToJSON)),
    };
}
exports.PodcastShowsResponseToJSON = PodcastShowsResponseToJSON;
